module.exports = __webpack_public_path__ + "img/Gallery_2_13.186f1a15.jpeg";